import { render } from "./newSpecimen.vue?vue&type=template&id=4abaca14"
import script from "./newSpecimen.vue?vue&type=script&lang=js"
export * from "./newSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__